import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_1_4821)" }, [
      _createElementVNode("path", {
        d: "M12.373 1.321C11.3511 0.905201 10.2346 0.778131 9.14533 0.953658C8.05609 1.12919 7.03601 1.60056 6.19641 2.31634C5.35682 3.03212 4.72999 3.96478 4.38435 5.01253C4.03871 6.06028 3.98753 7.18285 4.23641 8.25771L0.585665 11.9077L1.58796 12.9093L5.82875 8.66854L5.70266 8.26054C5.45485 7.45976 5.43043 6.6065 5.63203 5.79286C5.83363 4.97921 6.2536 4.23607 6.84662 3.64362C7.39316 3.09639 8.06881 2.69574 8.81114 2.47871C9.55348 2.26168 10.3385 2.23527 11.0938 2.40191L8.09896 5.39675L11.6052 8.903L14.6 5.90675C14.7666 6.66205 14.7401 7.44715 14.5229 8.18949C14.3058 8.93183 13.905 9.60745 13.3576 10.1539C12.7652 10.7469 12.022 11.1669 11.2084 11.3685C10.3947 11.5701 9.54149 11.5457 8.74071 11.2979L8.33341 11.1718L4.09191 15.4133L5.0935 16.4149L8.74425 12.7648C9.8191 13.0137 10.9417 12.9625 11.9894 12.6169C13.0372 12.2713 13.9698 11.6444 14.6856 10.8048C15.4014 9.96524 15.8728 8.94515 16.0483 7.85591C16.2238 6.76667 16.0968 5.65015 15.681 4.62821L15.501 4.18621L14.3167 4.18762L11.6052 6.89912L10.1021 5.39675L12.8136 2.68525L12.815 1.50091L12.373 1.321ZM5.84504 10.1546L2.33879 13.6609L3.34037 14.6625L6.84662 11.1562L5.84504 10.1546Z",
        fill: "#AA1E2D"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_1_4821" }, [
        _createElementVNode("rect", {
          width: "17",
          height: "17",
          fill: "white",
          transform: "matrix(-1 0 0 1 17 0)"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }